import { useEffect, useState } from "react";
import { subscribeTelegramViewport } from "@/utils/telegramViewport";

/**
 * Live inset from the layout viewport bottom to the visible Mini App
 * bottom. iOS often leaves `position: fixed` stuck at the compact-sheet
 * position after expand; this offset corrects it.
 */
export function useTelegramViewportBottomOffset(): number {
  const [bottom, setBottom] = useState(0);

  useEffect(() => {
    const update = () => {
      const visual = window.visualViewport;
      if (!visual) {
        setBottom(0);
        return;
      }
      const inset =
        window.innerHeight - visual.height - visual.offsetTop;
      setBottom(Math.max(0, Math.round(inset)));
    };

    update();
    return subscribeTelegramViewport(update);
  }, []);

  return bottom;
}
